var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.625H13V10.125H3V7.625Z",
    fill: "#EFD6AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 10.75H11.75V14.5H4.25V10.75Z",
    fill: "#EFD6AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2L5.5 6.375H3.625L3.625 2L5.5 2Z",
    fill: "#EFD6AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2L3 7H13L8 2Z",
    fill: "#EFD6AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle);
export default __webpack_public_path__ + "static/media/single.a8958315e716735e2172083c942b6a22.svg";
export { ForwardRef as ReactComponent };